<template lang="html">
  <layout>
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-toolbar flat color="rgba(0,0,0,0)" prominent>
          <h1>Job - {{ job.name }}</h1>
          <v-spacer></v-spacer>
          <v-select
            :items="['APPROVED','REQUEST EDITS','DENIED']"
            v-model="job.approval_status"
            @change="approvalAction()"
            label="Status"/>
        <v-dialog
          v-model="approveDialog"
          persistent
          max-width="500px"
          transition="dialog-transition">
          <v-card>
            <v-card-title primary-title class="primary">
              <span class="headline white--text">{{approvalInfo.headline}}</span>
            </v-card-title>
            <v-card-text>
              <v-textarea outline
                label="Comment"
                name="name"
                v-model="approvalInfo.comment"
              ></v-textarea>
              <v-checkbox label="Make Comment Private to Administrators?" value="false" v-model="approvalInfo.private" color="primary"></v-checkbox>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="red" dark @click="approveDialog = false, approvalInfo = [], job.approval_status = ''">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="sendApproval">{{approvalInfo.submit}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-toolbar>
        <v-flex md8>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex md6>
                  <v-card flat>
                    <v-card-title primary-title>
                      <span class="headline">Invoices</span>
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex md3 v-for="invoice in job.invoices" :key="invoice.id">
                          <v-img :src='invoice.invoice_file.thumb.url' @click="dialog = true, editInvoice = invoice" :style="{ cursor: 'pointer'}"/>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex md6>
                  <v-card flat>
                    <v-card-title primary-title>
                      <span class="headline">Photos</span>
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex md12>
                          <span class="subheading">Before:</span>
                        </v-flex>
                        <v-flex md3 v-for="photo in job.before_photos" :key="photo.id">
                          <v-card flat @click="lightbox = true, lightboxImage = photo.photo_file.url"><v-img :src='photo.photo_file.thumb.url' :style="{ cursor: 'pointer'}" /></v-card>
                        </v-flex>
                        <v-flex md12>
                          <span class="subheading">After:</span>
                        </v-flex>
                        <v-flex md3 v-for="photo in job.after_photos" :key="photo.id">
                          <v-img :src='photo.photo_file.thumb.url' @click="lightbox = true, lightboxImage = photo.photo_file.url" :style="{ cursor: 'pointer'}"/>
                        </v-flex>
                      </v-layout>
                      <v-dialog
                        v-model="lightbox"
                        transition="dialog-transition">
                        <v-card>
                          <v-img :src='lightboxImage' max-height="100%" contain aspect-ratio="2"/>
                        </v-card>
                      </v-dialog>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md4>
          <v-layout column wrap>
            <v-flex>
              <v-card>
                <v-card-title primary-title>
                  <span class="headline">Details</span>
                </v-card-title>
                <v-card-text>
                  Name:
                  <span class="right">{{ job.name }}</span>
                  <br/>
                  Total:
                  <span class="right">{{ Number(job.job_total_amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
                  <br/>
                  Co-op:
                  <span class="right">{{ Number(job.job_total_co_op_amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
                  <br/>
                  Remodeler:
                  <span class="right">{{ job.remodeler_name }}</span>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card>
                <v-card-title primary-title>
                  <span class="headline">Comments</span>
                </v-card-title>
                <v-card-text>
                  <v-list two-line subheader>
                    <v-list-tile  v-for="comment in job.comments" :key="comment.id">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{comment.content}}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          Added: {{comment.created_at | moment("dddd, MMMM Do YYYY")}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-action v-if="comment.is_private">
                        <v-btn icon>
                          <v-icon color="grey lighten-1">fa fa-lock</v-icon>
                        </v-btn>
                      </v-list-action>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="dialog"
        v-if="dialog"
        fullscreen
        persistent
        scrollable
        transition="dialog-bottom-transition">
        <invoice :invoice="editInvoice" :dialog.sync="dialog" :jobId="job.job_id" />
      </v-dialog>
    </v-container>
  </layout>
</template>

<script>
import Layout from '@/shared/Layout'
import invoice from './invoice'

export default {
  data () {
    return {
      job: '',
      dialog: false,
      approveDialog: false,
      approvalInfo: {
        private: false
      },
      lightbox: false,
      lightboxImage: '',
      editInvoice: ''
    }
  },
  components: {
    Layout,
    invoice
  },
  methods: {
    sendApproval () {
      this.$http({
        method: 'put',
        url: '/admin/jobs/' + this.$route.params.id,
        data: {
          approval_action: this.approvalInfo.action,
          comment: this.approvalInfo.comment,
          comment_is_private: this.approvalInfo.private
        }
      }).then((response) => {
        this.approveDialog = false
        this.$router.push('/admin/jobs')
      })
    },
    approvalAction () {
      this.approveDialog = true
      if (this.job.approval_status === 'APPROVED') {
        this.approvalInfo.headline = 'Approve Job'
        this.approvalInfo.submit = 'Approve'
        this.approvalInfo.action = 'DO_APPROVE'
      } else if (this.job.approval_status === 'REQUEST EDITS') {
        this.approvalInfo.headline = 'Request Edits'
        this.approvalInfo.submit = 'Send'
        this.approvalInfo.action = 'DO_REQUEST_EDITS'
      } else if (this.job.approval_status === 'DENIED') {
        this.approvalInfo.headline = 'Deny Job'
        this.approvalInfo.submit = 'Deny'
        this.approvalInfo.action = 'DO_DENY'
      }
    }
  },
  mounted () {
    this.$http({
      method: 'get',
      url: '/admin/jobs/' + this.$route.params.id
    }).then((response) => {
      this.job = response.data
    })
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/Jobs/job.vue